import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../../themes/redesignTokens";

export interface FormSectionProps {
  icon?: React.ReactNode;
  label: string;
  variant?: "header" | "label";
  children: React.ReactNode;
}

/**
 * Section header with icon + label. Groups related fields within a FormCard.
 *
 * Two variants:
 *   - "header" (default): icon + 12px uppercase bold label (from SR sectionHeaderSx)
 *   - "label": 16-18px bold heading (from RFS headingSx)
 */
const FormSection: React.FC<FormSectionProps> = ({
  icon,
  label,
  variant = "header",
  children,
}) => {
  if (variant === "label") {
    return (
      <Box>
        <Box
          sx={{
            fontFamily: dt.font,
            fontSize: { xs: "16px", md: "18px" },
            fontWeight: 700,
            color: dt.textPrimary,
            letterSpacing: "0.1px",
            mb: 1,
          }}
        >
          {label}
        </Box>
        {children}
      </Box>
    );
  }

  // variant === "header" (default)
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          mb: 1,
        }}
      >
        {icon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& .MuiSvgIcon-root": {
                fontSize: 16,
                color: dt.textMuted,
              },
            }}
          >
            {icon}
          </Box>
        )}
        <Box
          sx={{
            fontFamily: dt.font,
            fontSize: "12px",
            fontWeight: 700,
            color: dt.textSecondary,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {label}
        </Box>
      </Box>
      {children}
    </Box>
  );
};

export default FormSection;
